// sdk/env.ts
import type { EnvConfig } from "@/types";

let _env: EnvConfig | null = null;

export function initSdk(config: EnvConfig) {
  _env = config;
}

export function getEnvConfig(): EnvConfig | null {
  if (!_env) {
    console.warn(
      "SDK environment not initialized. Call initSdk({...}) before using <sb-provider>.",
    );
  }
  return _env;
}
